import React from "react";

const PartnerFeatures = () => {
  return (
    <section className="bg-white border-b py-8">
      <div className="container max-w-5xl mx-auto m-8">
        <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
          Ihre Vorteile
        </h2>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Einfach und schnell installierbar
            </h3>
            <p className="text-gray-600 mb-8">
              Einfach auf jedem handelsüblichen Android Smartphone/Tablet zu
              installieren und optional mit ausgewählten{" "}
              <a href="#pos" className="text-yellow-500">
                Kassensystemen
              </a>{" "}
              kombinierbar.
            </p>
            <p className="text-gray-600 mb-8 font-bold">
              In Krisenzeiten ist dies besonders wichtig, weil Gäste und Kunden
              nur durch elektronische Bestellungen und Lieferung erreichbar
              sind.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={require("./../images/rocket.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={require("./../images/protected.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                Gleicher Service bei geringerem Risiko
              </h3>
              <p className="text-gray-600 mb-8">
                Mit getsby funktioniert das Bestellen und Bezahlen in
                Gastro-Betrieben über das Smartphone, also ohne direkten
                persönlichen Kontakt mit den Service-Mitarbeitern. Damit lässt
                sich eine mögliche Ansteckungsgefahr vermindern.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Schneller Tisch Umschlag
            </h3>
            <p className="text-gray-600 mb-8">
              Langes Aufnehmen von Bestellungen und vor allem lästiges Kassieren
              fallen weg. Wer seine Speisen vor Ort im Lokal genießt, kann
              jederzeit aufstehen und gehen, ohne auf Service-Personal warten zu
              müssen, denn jeder Gast bezahlt einfach elektronisch mit dem
              eigenen Smartphone.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={require("./../images/stopwatch.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={require("./../images/like.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                Keine entgangenen Bestellungen
              </h3>
              <p className="text-gray-600 mb-8">
                Keine „Stoßzeiten“ mit vielen wartenden Gästen, dafür viel
                Spielraum für die Küchen-Teams, denn durch die übersichtlichen
                Bestellvorgänge mit getsby lassen sich Küchenabläufe optimal
                planen.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Benachrichtigungen
            </h3>
            <p className="text-gray-600 mb-8">
              Gäste werden automatisch über den Bestellstatus, Aktionen und
              Rabatte informiert.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={require("./../images/notification.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={require("./../images/worldwide.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                CO2 neutral
              </h3>
              <p className="text-gray-600 mb-8">
                Keine „meterlangen“ Kassenbons, stattdessen können Rechnungen
                CO2-sparend auf dem Smartphone des Gastes abgerufen werden.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Höchste Flexibilität
            </h3>
            <p className="text-gray-600 mb-8">
              Mit getsby lassen sich Krisen, Personalmangel oder andere
              kritische Punkte leichter abfangen. Ihre Servicequalität bleibt
              hoch!
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={require("./../images/magic-wand.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerFeatures;
